import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import ArticlesContent from './ArticlesContent';
import useDebounce from '../../../common/components/UseDebounce';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function ArticlesContainer({
  match,
  history,
  getUserManagementList,
  userManagementList,
  userManagementListPager,
  isLoading,
  removeUserManagement,
  showUserManagement,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add News Article',
      modalSize: 'modal-lg',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update News Article',
      modalSize: 'modal-lg',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removeUserManagement(data.id, () => {
          getUserManagementList({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/news/articles/${id}`);
            showUserManagement(id);
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   getUserManagementList({ ...formData });
  // };

  useEffect(() => {
    getUserManagementList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getUserManagementList({ q: formData.keyword, sort_by: 'desc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:articleId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="News List"
            getData={getUserManagementList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:articleId?`}
            listName="Articles"
            label="Articles"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <p> {_.get(item, 'attributes.title')} </p>
              </div>
            )}
            isLoading={isLoading}
            selected={params.articleId}
            data={userManagementList}
            dataPager={userManagementListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:articleId?`}
                    render={() => (
                      <ArticlesContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:articleId?`}
                  render={() =>
                    !params.articleId && userManagementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(userManagementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

ArticlesContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getUserManagementList: PropTypes.instanceOf(Function).isRequired,
  userManagementList: PropTypes.instanceOf(Array).isRequired,
  userManagementListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  userManagementList: _.get(api, `${c.GET_USER_MANAGEMENT}.list`) || [],
  userManagementListPager: _.get(api, `${c.GET_USER_MANAGEMENT}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_USER_MANAGEMENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ArticlesContainer);
